export function init(selector, { onFailed, onSuccess }) {
    if (typeof window.IdealPostcodes === 'undefined') {
        return;
    }

    const countries = window.Gifted.addressLookup.countries ?? [];

    // Only countries Gifted will post to: no auto-detection, and no country switcher for a single choice.
    // An empty list means the hotel posts elsewhere itself, so the finder keeps its own defaults.
    const countryLimit = countries.length
        ? {
            defaultCountry: countries[0],
            detectCountry: false,
            hideToolbar: countries.length === 1,
            restrictCountries: countries,
        }
        : {};

    window.IdealPostcodes.AddressFinder.setup({
        apiKey: window.Gifted.addressLookup.key,
        ...countryLimit,
        inputField: selector,
        msgPlaceholder: '',
        msgPlaceholderCountry: '',
        queryOptions: {
            bias_ip: true,
        },

        onFocus: () => {
            document.querySelector(selector).parentNode.parentNode.classList.add('has-autocomplete');
        },

        onBlur: () => {
            document.querySelector(selector).parentNode.parentNode.classList.remove('has-autocomplete');
        },

        onFailedCheck: () => {
            if (onFailed) onFailed();
        },

        onAddressRetrieved: (address) => {
            if (onSuccess) onSuccess(address);
        },
    });
}
